export default __webpack_public_path__ + "static/media/58_Random_Left.d080fcff.mp4";